import styled from "styled-components";
import { Table } from "../../styles-components/Table";
import { Label } from "../../styles-components/FormItens";

export const TablePrices = styled(Table)`
`;

export const FilterGroup = styled.div`
  margin-top: 20px;
`;

export const Filter = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  ${Label} {
    margin-right: 10px;
    font-weight: 500;
    font-size: 1.2rem;
  }

  @media (max-width: 760px) {
    flex-direction: column;
    align-items: flex-start;

    ${FilterSelect} {
      width: 100%
    }
  }
`;

export const FilterSelect = styled.select`
  width: auto;

  @media (max-width: 760px) {
    width: 100%
  }
`;
